import api from '../../../axios/axios-api'

export default {
  async register(context, payload) {
    try {
      await api.post('/auth/registro', {
        tdId: payload.tdId,
        nroDoc: payload.nroDoc,
        email: String(payload.email).trim(),
        password: payload.password,
      }, { skipGlobalErrorAlert: true })
      return { ok: true }
    } catch (e) {
      const data = e?.response?.data
      return {
        ok: false,
        status: e?.response?.status,
        errorCode: data?.errorCode ?? data?.ErrorCode,
        message: data?.message ?? data?.Message ?? data?.title ?? data?.detail,
      }
    }
  },

  async validateAccount(context, payload) {
    try {
      await api.post('/auth/validar-cuenta', {
        userId: payload.userId,
        emailConfirmationToken: payload.emailConfirmationToken,
      })
      return { ok: true }
    } catch {
      return { ok: false }
    }
  },

  async confirmarCambioEmail(context, payload) {
    try {
      await api.post('/auth/confirmar-cambio-email', {
        userId: payload.userId,
        newEmail: String(payload.newEmail).trim(),
        token: payload.token,
      })
      return { ok: true }
    } catch {
      return { ok: false }
    }
  },

  async loginWithDocument(context, payload) {
    try {
      context.commit('portalHome/resetPortalHomeSession', null, { root: true })
      const { data } = await api.post(
        '/auth/login-documento',
        {
          tdId: payload.tdId,
          nroDoc: payload.nroDoc,
          password: payload.password,
        },
        { skipGlobalErrorAlert: true },
      )
      const token = data.accessToken
      if (token) {
        localStorage.setItem('token', token)
      }
      return { ok: true, data }
    } catch (e) {
      const data = e?.response?.data
      return {
        ok: false,
        status: e?.response?.status,
        errorCode: data?.errorCode ?? data?.ErrorCode,
        message: data?.message ?? data?.Message ?? data?.title ?? data?.detail,
      }
    }
  },

  async solicitarRestablecimiento(context, payload) {
    try {
      await api.post('/auth/solicitar-restablecimiento', {
        tdId: payload.tdId,
        nroDoc: payload.nroDoc,
      })
      return { ok: true }
    } catch {
      return { ok: false }
    }
  },

  async restablecerPassword(context, payload) {
    try {
      await api.post('/auth/restablecer-password', {
        userId: payload.userId,
        token: payload.token,
        newPassword: payload.newPassword,
      })
      return { ok: true }
    } catch {
      return { ok: false }
    }
  },

  async cambiarPassword(context, payload) {
    try {
      await api.post('/auth/cambiar-password', {
        passwordActual: payload.passwordActual,
        passwordNueva: payload.passwordNueva,
      })
      return { ok: true }
    } catch (e) {
      const code = e?.response?.data?.errorCode
      return { ok: false, errorCode: code || 'request_failed' }
    }
  },
}
